
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"16","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1 2h14a1 1 0 100-2H1a1 1 0 100 2zM15 8H1a1 1 0 110-2h14a1 1 0 110 2zM15 14H1a1 1 0 110-2h14a1 1 0 110 2z","fill":"#D1D1D1"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      